import _ from 'lodash';
import renderHTML from 'react-render-html';
import format from 'string-template';

/**
 * Retourne du DOM React à partir d'une string contenant des balises HTML et remplace les variables ({0}, {1}....) avec params
 * @param {String} html string contenant des balises html
 * @param {Spread Operator, variable de tout type possible} params variables à remplacer dans la string 'html'
 * example :    html = '<p>L'ardèche c'est {0} mieux que les {1} autres département français.</p>'
 *              params = '100 fois mieux', 101
 *              resultat = <p>L'ardèche c'est 100 fois mieux mieux que les 101 autres département français.
 */
/**
 * Corrige les imbrications HTML invalides (ex : <ul> dans <p>, fréquent dans les
 * conditions des bons d'achat, dont le contenu n'est pas maîtrisé par le front)
 * en s'appuyant sur le parseur HTML du navigateur, qui applique la règle
 * standard : un élément de bloc ferme le <p> ouvert. Les <p> vides résultant de
 * cette découpe sont supprimés.
 */
function normalizeHtmlNesting(html) {
    // Sans balise, rien à normaliser : ne touche pas aux wordings en texte brut.
    if (html.indexOf('<') === -1) {
        return html;
    }
    const container = document.createElement('div');
    container.innerHTML = html;
    container.querySelectorAll('p').forEach(p => {
        // Seuls les <p> strictement vides (aucun nœud, artefact du </p> orphelin
        // après découpe) sont supprimés ; un <p>&nbsp;</p> d'espacement est gardé.
        if (p.childNodes.length === 0) {
            p.remove();
        }
    });
    return container.innerHTML;
}

export function convertHtmlToReactDomWithParams(html, ...params) {
    return _.isString(html) && html !== ''
        ? renderHTML(normalizeHtmlNesting(format(html, params)))
        : '';
}

export function convertHrefLink(link) {
    if (_.startsWith(link, 'http')) {
        return link;
    }
    const uri = _.startsWith(link, '/') ? link.substring(1) : link;
    return `https://${uri}`;
}

export function removeListMarker(content) {
    if (!content) return content;
    return content.replaceAll('&bull;', '').replaceAll('• ', '');
}



// WEBPACK FOOTER //
// ./src/utils/htmlUtils.js